import { render, staticRenderFns } from "./AddAsset.vue?vue&type=template&id=3596c50c&scoped=true&"
import script from "./AddAsset.vue?vue&type=script&lang=js&"
export * from "./AddAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596c50c",
  null
  
)

export default component.exports